import { getCurrentEnvConfig } from './environment'

// Get the current environment configuration
const envConfig = getCurrentEnvConfig()

// Export the base URL for the current environment
export const API_BASE_URL = envConfig.apiBaseUrl

// Helper function to get full API URL
export const getApiUrl = (endpoint) => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith("/") ? endpoint.slice(1) : endpoint
  return `${API_BASE_URL}/${cleanEndpoint}`
}

// Common API endpoints
export const API_ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    LOGIN: "auth/login",
    REGISTER: "auth/register",
    ME: "auth/me",
    FORGOT_PASSWORD: "auth/forgot-password",
    VERIFY_RESET_CODE: "auth/verify-reset-code",
    RESET_PASSWORD: "auth/reset-password",
    GOOGLE: "auth/google",
  },
  // Generation endpoints
  GENERATIONS: {
    LIST: "generations",
    PROMPT_TO_IMAGE: "generate/prompt-to-image",
    TRANSFORM_IMAGE: "generate/transform-image", 
    TRANSFORM_TO_VIDEO: "generate/transform-to-video",
    STATS: "stats",
    DELETE: "generations/:id", // Add endpoint for deleting a generation
  },
  // Payment endpoints
  PAYMENT: {
    CREATE_ORDER: "payment/create-order",
  },
}

// Debug helper for development
export const logApiCall = (method, url, data = null) => {
  if (envConfig.debug) {
    console.log(`🌐 API Call: ${method} ${url}`, data ? { data } : '')
  }
}